<div class="dialog-container">
  <div mat-dialog-title>
    <i class="fa fa-check"></i>
  </div>
  <div mat-dialog-content>
    <h1>Done</h1>
    <p>Your mail has been sent successfully. </p>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="close()">Ok</button>
  </div>
</div>